import React from 'react';
import Logo from "../images/logo/Quick-Care.png";
import SearchIcon from '@mui/icons-material/Search';
import Profile from "../images/avatar.png";
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import { Link } from 'react-router-dom';
 
const Header = ({ isSidebarOpen, toggleSidebar, title }) => {
    return (
        <div className='w-full flex flex-row items-center justify-between py-3 px-3 lg:px-8 md:pb-4 bg-white md:border-b-2 instrument-sans-semibold'>
            <div className='md:hidden' onClick={toggleSidebar}>
                {isSidebarOpen ? <ClearIcon /> : <MenuIcon />}
            </div>

            <Link to='/' className='lg:hidden'>
                <img src={Logo} alt="Logo" className='w-32 h-15'/>
            </Link>
            
            <div className='hidden md:block'>
                <h1 className='text-2xl font-semibold text-[#828282]'>
                    {title}
                </h1>
            </div>

            <img src={Profile} alt="" className='w-14 h-14'/>
        </div>
    );
};

export default Header;